import "./nosotros.css";
import Employer from "../../components/employer";
import RegisterTwo from "../../components/registertwo";
import { FaBullseye, FaEye } from "react-icons/fa"; // Íconos para Misión y Visión
import SocialFloatingMenu from "../../components/SocialFloatingMenu"; // Importa el SocialFloatingMenu

const Nosotros = () => {
  return (
    <div className="nosotros-container">
      {/* Introducción */}
      <section className="nosotros-intro text-center">
        <h1 className="title">NOSOTROS</h1>
        <p className="description">
          WorkingUnidos es el primer hub digital en español dedicado a proporcionar
          recursos confiables para la integración socioeconómica de los latinos en Estados
          Unidos. Conectamos a hispanoparlantes con instituciones y organizaciones que ofrecen
          servicios con afinidad lingüística y cultural, facilitando el acceso a educación, empleo,
          emprendimiento y servicios migratorios.
        </p>
      </section>

      {/* Sección de Misión y Visión en formato de tarjetas */}
      <section className="nosotros-cards-section">
        <div className="row g-4">
          {/* Misión */}
          <div className="col-md-6">
            <div className="card nosotros-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaBullseye className="icon" />
                </div>
                <h2 className="card-title">MISIÓN</h2>
                <p className="card-text">
                  Ser el hub digital líder bilingüe que proporcione recursos confiables para la
                  integración socioeconómica y el desarrollo de las potencialidades de los latinos en Estados Unidos.
                </p>
              </div>
            </div>
          </div>
          {/* Visión */}
          <div className="col-md-6">
            <div className="card nosotros-card">
              <div className="card-body text-center">
                <div className="icon-circle">
                  <FaEye className="icon" />
                </div>
                <h2 className="card-title">VISIÓN</h2>
                <p className="card-text">
                  Convertirse en el referente digital bilingüe para la comunidad latina en Estados Unidos,
                  proporcionando recursos confiables en educación, empleo, emprendimiento e inmigración.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Sección extra: Registro y Empleadores */}
      <section>
        <RegisterTwo />
        <Employer />
      </section>

      {/* Sección de Contacto */}
      <section className="contact-section text-center my-5">
        <h2 className="contact-title text-warning">CONTÁCTANOS</h2>
        <p className="contact-description">
          ¿Tienes alguna pregunta o necesitas más información? Contáctanos y estaremos encantados de ayudarte.
        </p>
        <form className="contact-form mt-4">
          <div className="row g-3">
            <div className="col-md-6">
              <input type="text" className="form-control" placeholder="NOMBRE" required />
            </div>
            <div className="col-md-6">
              <input type="email" className="form-control" placeholder="CORREO ELECTRÓNICO" required />
            </div>
            <div className="col-12">
              <input type="text" className="form-control" placeholder="ASUNTO" required />
            </div>
            <div className="col-12">
              <textarea className="form-control" rows="4" placeholder="MENSAJE" required></textarea>
            </div>
          </div>
          <button type="submit" className="btn contact-btn mt-3">
            ENVIAR MENSAJE
          </button>
        </form>
      </section>

      {/* Social Floating Menu */}
      <SocialFloatingMenu />
    </div>
  );
};

export default Nosotros;